// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__lEYmY","colBig":"styles_colBig__1DVT3","colSmall":"styles_colSmall__sOIe7","shopifyNameWrapper":"styles_shopifyNameWrapper__1fo-F"};